import Image from "next/image";

const brandLogos = [
  { name: "Heinz", file: "heinz.png", width: 120, height: 48 },
  { name: "Dove", file: "dove.png", width: 108, height: 48 },
  { name: "New Balance", file: "new-balance.png", width: 84, height: 54 },
  { name: "Oral-B", file: "oral-b.png", width: 120, height: 42 },
  { name: "OXO", file: "oxo.png", width: 96, height: 42 },
  { name: "Dyson", file: "dyson.png", width: 120, height: 36 },
  { name: "Singer", file: "singer.png", width: 150, height: 42 },
  { name: "HP", file: "hp.png", width: 66, height: 54 },
  { name: "Huggies", file: "huggies.png", width: 135, height: 42 },
];

type ClientLogosProps = {
  title: string;
};

export default function ClientLogos({ title }: ClientLogosProps) {
  return (
    <section className="pb-16 pt-8 bg-white">
      <div className="max-w-[1400px] mx-auto px-6">
        <h2
          className="text-center mb-16"
          style={{
            fontFamily: "var(--font-display), 'Hanken Grotesk', sans-serif",
            fontSize: "clamp(28px, 3vw, 40px)",
            fontWeight: 600,
            color: "#1B1C30",
            letterSpacing: "-0.02em",
          }}
        >
          {title}
        </h2>
        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-6 md:gap-x-14">
          {brandLogos.map((logo) => (
            <div key={logo.name} className="opacity-80 hover:opacity-100 transition-opacity duration-300 grayscale-0">
              <Image
                src={`/brand-logos/${logo.file}`}
                alt={logo.name}
                width={logo.width}
                height={logo.height}
                className="object-contain"
                style={{ height: logo.height, width: "auto" }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
